module.exports = __webpack_public_path__ + "img/plus-primary-photo.3b74c116.jpeg";